export default __webpack_public_path__ + "../staticImages/login_background_fallback.png";